import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { X, Cookie } from "lucide-react";

const KEY = "ncp_cookie_ack_v1";

export const CookieBanner = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const acked = localStorage.getItem(KEY);
    if (!acked) {
      const t = setTimeout(() => setShow(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(KEY, new Date().toISOString());
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 md:max-w-md z-[60]"
    >
      <div className="rounded-2xl border border-black/10 bg-[#FDFCF8] shadow-[0_8px_30px_rgb(0,0,0,0.08)] p-5">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 shrink-0 rounded-full bg-[#F3F1E7] flex items-center justify-center">
            <Cookie size={16} strokeWidth={1.5} className="text-[#739072]" />
          </div>
          <div className="flex-1">
            <p className="font-serif text-base text-[#2D332F] mb-1.5">
              A note on cookies &amp; privacy
            </p>
            <p className="text-sm text-[#5C6661] leading-relaxed">
              This site uses essential cookies to keep your session secure.
              We don&rsquo;t sell or share your data. See our{" "}
              <Link
                to="/privacy"
                data-testid="cookie-banner-privacy"
                className="underline text-[#739072]"
              >
                Privacy Notice
              </Link>{" "}
              for details.
            </p>
            <div className="mt-4 flex items-center gap-2">
              <button
                onClick={accept}
                data-testid="cookie-banner-accept"
                className="inline-flex items-center px-4 py-2 rounded-full bg-[#2D332F] text-[#FDFCF8] text-sm hover:bg-[#739072] transition"
              >
                Got it
              </button>
            </div>
          </div>
          <button
            onClick={accept}
            data-testid="cookie-banner-close"
            aria-label="Dismiss"
            className="text-[#5C6661] hover:text-[#2D332F] p-1 -m-1"
          >
            <X size={16} strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
};
